export const manualTransferTypeRef = {
  transferIn: 'transfer-in',
  'transfer-in': 'transfer-in',
  transferOut: 'transfer-out',
  'transfer-out': 'transfer-out',
};

export const manualDefiTypeRef = {
  liquidityDeposit: 'liquidity-deposit',
  'liquidity-deposit': 'liquidity-deposit',
  liquidityWithdrawal: 'liquidity-withdrawal',
  'liquidity-withdrawal': 'liquidity-withdrawal',
  stakeDeposit: 'stake-deposit',
  'stake-deposit': 'stake-deposit',
  stakeReward: 'stake-reward',
  'stake-reward': 'stake-reward',
  stakeWithdrawal: 'stake-withdrawal',
  'stake-withdrawal': 'stake-withdrawal',
  swap: 'swap',
};

export const manualLiquidityPoolTypes = [
  manualDefiTypeRef.liquidityDeposit,
  manualDefiTypeRef.liquidityWithdrawal,
];

export const manualDefiFormatTypeRef = {
  liquidityDeposit: true,
  liquidityWithdrawal: true,
  'liquidity-deposit': true,
  'liquidity-withdrawal': true,
  swap: true,
};

// Should match activeDefiProviders object keys except manual
export const manualDefiProviders = [
  'aave',
  'curve',
  'dydx',
  'maker',
  'pancakeswap',
  'sushi',
  'uniswap',
  'vesper',
  'yearn',
  '1inch',
  'generic',
];

export const manualTxEntryDescriptionRef = {
  standard:
    'This option allows for capturing general transfer activities of a cryptocurrency wallet.',
  defi: `Decentralized Finance refers to interactions with smart contracts on blockchains to 
  perform various financial transactions.`,
};

export const manualOrderTypeRef = {
  buy: 'buy',
  sell: 'sell',
  deposit: 'deposit',
  withdrawal: 'withdrawal',
  crypto: 'crypto-crypto',
};

export const contextTitleRef = {
  standard: 'Standard',
  defi: 'DeFi Activity',
};

export const categoryTypeMappings = {
  liquidityPoolDeposit_defi: {
    incoming: {},
    outgoing: {
      exchange: null,
      wallet: manualDefiTypeRef.liquidityDeposit,
    },
  },
  liquidityPoolWithdrawal_defi: {
    incoming: {
      exchange: null,
      wallet: manualDefiTypeRef.liquidityWithdrawal,
    },
    outgoing: {},
  },
  stakingDeposit_defi: {
    incoming: {},
    outgoing: {
      exchange: null,
      wallet: manualDefiTypeRef.stakeDeposit,
    },
  },
  stakingRewards_defi: {
    incoming: {
      exchange: null,
      wallet: manualDefiTypeRef.stakeReward,
    },
    outgoing: {},
  },
  stakingWithdrawal_defi: {
    incoming: {
      exchange: null,
      wallet: manualDefiTypeRef.stakeWithdrawal,
    },
    outgoing: {},
  },
  swap_defi: {
    incoming: {
      exchange: null,
      wallet: manualDefiTypeRef.swap,
    },
    outgoing: {
      exchange: null,
      wallet: manualDefiTypeRef.swap,
    },
  },
  acquisition_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  airdrop_standard: {
    incoming: {
      exchange: null,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  buy_standard: {
    incoming: {
      exchange: manualOrderTypeRef.buy,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  collateralLiquidation_standard: {
    incoming: {},
    outgoing: {
      exchange: manualOrderTypeRef.withdrawal,
      wallet: manualTransferTypeRef.transferOut,
    },
  },
  collateralRetrieval_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  collateralRetrievalNonTaxable_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  collateralize_standard: {
    incoming: {},
    outgoing: {
      exchange: null,
      wallet: manualTransferTypeRef.transferOut,
    },
  },
  collateralizeNonTaxable_standard: {
    incoming: {},
    outgoing: {
      exchange: null,
      wallet: manualTransferTypeRef.transferOut,
    },
  },
  donation_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {
      exchange: manualOrderTypeRef.withdrawal,
      wallet: manualTransferTypeRef.transferOut,
    },
  },
  earnRewards_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  fee_standard: {
    incoming: {},
    outgoing: {
      wallet: manualTransferTypeRef.transferOut,
      exchange: null,
    },
  },
  forkIncome_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  gift_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {
      exchange: manualOrderTypeRef.withdrawal,
      wallet: manualTransferTypeRef.transferOut,
    },
  },
  interestIncome_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  interestPayment_standard: {
    incoming: {},
    outgoing: {
      exchange: manualOrderTypeRef.withdrawal,
      wallet: manualTransferTypeRef.transferOut,
    },
  },
  loanDisbursement_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  loanPayment_standard: {
    incoming: {},
    outgoing: {
      exchange: manualOrderTypeRef.withdrawal,
      wallet: manualTransferTypeRef.transferOut,
    },
  },
  miningIncome_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  sell_standard: {
    incoming: {},
    outgoing: {
      exchange: manualOrderTypeRef.sell,
      wallet: manualTransferTypeRef.transferOut,
    },
  },
  stakingDeposit_standard: {
    incoming: {},
    outgoing: {
      exchange: manualOrderTypeRef.withdrawal,
      wallet: manualTransferTypeRef.transferOut,
    },
  },
  stakingRewards_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  stakingWithdrawal_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  transfer_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {
      exchange: manualOrderTypeRef.withdrawal,
      wallet: manualTransferTypeRef.transferOut,
    },
  },
  withdrawal_standard: {
    incoming: {},
    outgoing: {
      exchange: manualOrderTypeRef.withdrawal,
      wallet: manualTransferTypeRef.transferOut,
    },
  },
  workIncome_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
      wallet: manualTransferTypeRef.transferIn,
    },
    outgoing: {},
  },
  fiatDeposit_standard: {
    incoming: {
      exchange: manualOrderTypeRef.deposit,
    },
    outgoing: {},
  },
  fiatWithdrawal_standard: {
    incoming: {},
    outgoing: {
      exchange: manualOrderTypeRef.withdrawal,
    },
  },
};

export const taxTxExceptionManualTypeRef = {
  [manualOrderTypeRef.buy]: 1,
  [manualTransferTypeRef.transferIn]: 1,
};

export const addedDefiColumnTypeRef = {
  liquidityPoolDeposit_defi: 1,
  liquidityPoolWithdrawal_defi: 1,
  swap_defi: 1,
};

export const liquidityExclusiveColumnTypeRef = {
  liquidityPoolDeposit_defi: 1,
  liquidityPoolWithdrawal_defi: 1,
};

export const sourceTypeRef = {
  wallet: 'wallet',
  exchange: 'exchange',
}

export const manualUIStandardCategories = [
  {
    canCreateManualEntry: true,
    dbValue: 'fee_standard',
    system: false,
    title: 'Fee',
    txSides: ['outgoing'],
    txSourceTypes: ['wallet'],
  },
  {
    canCreateManualEntry: true,
    dbValue: 'fiatDeposit_standard',
    system: false,
    title: 'Fiat Deposit',
    txSides: ['incoming'],
    txSourceTypes: ['exchange'],
  },
  {
    canCreateManualEntry: true,
    dbValue: 'fiatWithdrawal_standard',
    system: false,
    title: 'Fiat Withdrawal',
    txSides: ['outgoing'],
    txSourceTypes: ['exchange'],
  },
];

export const fiatCategoryDbValues = [
  'fiatDeposit_standard',
  'fiatWithdrawal_standard',
];

export const manualUIStandardCategoryRef =
  manualUIStandardCategories.reduce((acc, cat) => {
    acc[cat?.dbValue] = cat;
    return acc;
  }, {});
  
/**
 * Default tax category to assume for a given wallet transaction `type`.
 * Useful when an entry is loaded (e.g. from the backend) without an explicit
 * `taxCategory` and we need a sensible starting value for edit mode.
 */
export const defaultWalletTaxCategoryByType = {
  [manualDefiTypeRef.liquidityDeposit]: 'liquidityPoolDeposit_defi',
  [manualDefiTypeRef.liquidityWithdrawal]: 'liquidityPoolWithdrawal_defi',
  [manualDefiTypeRef.swap]: 'swap_defi',
  [manualDefiTypeRef.stakeDeposit]: 'stakingDeposit_defi',
  [manualDefiTypeRef.stakeWithdrawal]: 'stakingWithdrawal_defi',
  [manualDefiTypeRef.stakeReward]: 'stakingRewards_defi',
};

/**
 * Default tax category to assume for a given exchange order `type`.
 * Several categories share the same underlying `type` (e.g. `deposit` maps to
 * `acquisition_standard`, `collateralRetrieval_standard`, etc.); this ref
 * captures the most common default for bootstrapping an edit form.
 */
export const defaultExchangeTaxCategoryByType = {
  [manualOrderTypeRef.buy]: 'buy_standard',
  [manualOrderTypeRef.sell]: 'sell_standard',
  [manualOrderTypeRef.deposit]: 'acquisition_standard',
  [manualOrderTypeRef.withdrawal]: 'collateralLiquidation_standard',
};

export const categoryTypeSideRef = {
  donation_standard: {
    [manualOrderTypeRef.deposit]: 'incoming',
    [manualTransferTypeRef.transferIn]: 'incoming',
    [manualOrderTypeRef.withdrawal]: 'outgoing',
    [manualTransferTypeRef.transferOut]: 'outgoing',
  },
  gift_standard: {
    [manualOrderTypeRef.deposit]: 'incoming',
    [manualTransferTypeRef.transferIn]: 'incoming',
    [manualOrderTypeRef.withdrawal]: 'outgoing',
    [manualTransferTypeRef.transferOut]: 'outgoing',
  },
  transfer_standard: {
    [manualOrderTypeRef.deposit]: 'incoming',
    [manualTransferTypeRef.transferIn]: 'incoming',
    [manualOrderTypeRef.withdrawal]: 'outgoing',
    [manualTransferTypeRef.transferOut]: 'outgoing',
  },
};
